import * as React from 'react'
import { useMemo } from 'react'

import {
  CardListSummaryBar,
  ICardListState,
} from '~/client/src/shared/components/CardList'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { IResourceRecord } from '~/client/src/shared/resources/definitions/types'

import { filterSelectable } from '../filterSelectable'
import { useResourcePickerContext } from '../ResourcePickerContext'

interface IProps {
  items: IResourceRecord[]
  listState?: ICardListState<IResourceRecord>
  countLabel?: string
  portalSelector?: string
}

export const PickerCountRow: React.FC<IProps> = ({
  items,
  listState,
  countLabel,
  portalSelector,
}) => {
  const { mode, toggleGroup, selectedIds, isItemDisabled } =
    useResourcePickerContext()

  const selectableItems = useMemo(
    () => filterSelectable(items, selectedIds, isItemDisabled),
    [items, selectedIds, isItemDisabled],
  )

  const handleSelectAll = React.useCallback(() => {
    toggleGroup(selectableItems)
  }, [toggleGroup, selectableItems])

  const allSelected = useMemo(
    () =>
      selectableItems.length > 0 &&
      selectableItems.every(item => selectedIds.has(item.id)),
    [selectableItems, selectedIds],
  )
  const someSelected = useMemo(
    () =>
      !allSelected && selectableItems.some(item => selectedIds.has(item.id)),
    [allSelected, selectableItems, selectedIds],
  )
  const isMulti = mode === 'multi'

  return (
    <CardListSummaryBar
      selectAll={
        isMulti
          ? {
              checked: allSelected,
              indeterminate: someSelected,
              onToggle: handleSelectAll,
              ariaLabel: Localization.translator.selectAll,
            }
          : undefined
      }
      listState={listState}
      portalSelector={portalSelector}
    >
      {isMulti && selectedIds.size > 0
        ? Localization.translator.xSelected(selectedIds.size)
        : countLabel
          ? `${items.length} ${countLabel}`
          : Localization.translator.xItemsCount(items.length)}
    </CardListSummaryBar>
  )
}
